import EditTable from "./Table";
import * as hooks from "./hooks";

/**
 * @namespace EditTable
 */

/**
 * 兼容旧版本创建表格方法
 * @param {string} mainCode 表格主区域编码
 * @param {object} config 表格业务配置
 */

export default function EditTableOutput() {
    this.register("editTable"); // 生成 this.cardTableDataSource[id]
    return {
        ...Object.entries(hooks).reduce((wrappedHooks, [name, hook]) => {
            wrappedHooks[name] = (...rest) => {
                console.log('EditTable调用：', name, '参数为：', ...rest);
                try {
                    // console.time(`${name}耗时`);
                    let res = hook.call(this, ...rest);
                    // console.timeEnd(`${name}耗时`);
                    return res;
                } catch(e) {
                    console.error(e);
                }
            };
            return wrappedHooks;
        }, {}),
    };
}

EditTableOutput.component = EditTable;
EditTableOutput.displayName = "EditTable";
EditTableOutput.unfinished = ["editTableUnFinishedApi"];
